<template>
  <footer v-show="isFooterBarVisible" class="bg-white py-3 px-6">
    <level>
      <div>
        <b>&copy; {{ year }}, Generage Web Prices</b> &mdash; Prosteer Group
      </div>
    </level>
  </footer>
</template>

<script>
import { computed } from 'vue'
import Level from '@/Components/Dashboard/Level'

export default {
  name: 'FooterBar',
  components: {
    Level
  },
  setup () {
    const year = computed(() => new Date().getFullYear())

    const isFooterBarVisible = computed(() => true)

    return {
      year,
      isFooterBarVisible
    }
  }
}
</script>
